import { render, staticRenderFns } from "./KelengkapanCard.vue?vue&type=template&id=5cb46161&"
import script from "./KelengkapanCard.vue?vue&type=script&lang=js&"
export * from "./KelengkapanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports